import Validator from '@shared/validatorjs/src/validator'
import {
  UpdatePathSettingsRequest,
  UpdateField,
  FetchPathSettingsRequest,
} from './path-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getPathSettingsState } from './path-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-path-settings',
  templateUrl: './path-settings.component.html',
  styleUrls: ['./path-settings.component.css'],
})
export class PathSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getPathSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch(new FetchPathSettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      PATH_CLIENT_BASE_URL: 'required',
      PATH_IMAGE_UPLOAD: 'required',
      PATH_IMAGE_BASE_URL: 'required',
      PATH_RDN_GENERATION: 'required',
      PATH_DOCUMENT_UPLOAD: 'required',
      PATH_TEMP_FOLDER: 'required',
      PATH_DELIVERY_CONFIRMATION_UPLOAD: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      PATH_CLIENT_BASE_URL: 'client base url',
      PATH_IMAGE_UPLOAD: 'image upload path',
      PATH_IMAGE_BASE_URL: 'image base url',
      PATH_RDN_GENERATION: 'rdn generation path',
      PATH_DOCUMENT_UPLOAD: 'property document upload path',
      PATH_TEMP_FOLDER: 'temp folder path',
      PATH_DELIVERY_CONFIRMATION_UPLOAD: 'delivery confirmation upload path',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdatePathSettingsRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
